// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_backgroundTable__Ktc63 {
  padding-top: -40px !important;
  margin-left: 40px !important;
  margin-right: 40px !important;
  padding-bottom: 30px !important;
}

.styles_tabelaGeral__g6Yiw {
  background-color: #ffffff;
  border-radius: 0 0 6px 6px;
  padding-left: 4px !important;
  padding-right: 4px !important;
  margin-top: -28px !important;
  padding-bottom: 4px !important;
}

.styles_tabelaLoading__JS\\+Yh {
  background-color: #ffffff;
  border-radius: 0 0 6px 6px;
  padding-left: 4px !important;
  padding-right: 4px !important;
  padding-top: 150px !important;
  padding-bottom: 150px !important;
  margin-top: -28px !important;
  justify-content: center;
  align-content: center;
}

.styles_paginacaoTabela__Nn59a {
  padding: 0;
  border-radius: 0 0 6px 6px;
  background-color: #0f2047 !important;
  color: #ffffff !important;
}

.styles_tableHeader__-TOwt {
  border-radius: 6px 6px 0 0;
}

.styles_tabelaHeader__Svz-L {
  font-family: "Inter" !important;
  background-color: #0f2047 !important;
  color: #ffffff !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  padding-top: 2px !important;
  padding-bottom: 4px !important;
}

.styles_iconeEditar__CnFDs {
  color: #18316e !important;
}

.styles_iconeEditar__CnFDs:hover {
  transform: scale(0.95) !important;
}

.styles_iconeExcluir__gTgZ4 {
  color: #ff0000 !important;
  margin-left: 4% !important;
}

.styles_iconeAtivo__oKypm {
  width: 20px !important;
  height: auto !important;
}

.styles_boxAcoes__o7pUE {
  vertical-align: middle !important;
  display: flex;
  flex-direction: row;
}

.styles_customCell__UaEmR {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
  font-family: "Inter" !important;
  color: #000000 !important;
  word-wrap: break-word;
}

.styles_tableContainerFixa__x0zXN {
  overflow-x: hidden !important;
}

.styles_tabelaFixa__l\\+GGn {
  table-layout: fixed !important;
  width: 100% !important;
}

.styles_celulaTruncada__NnaRQ {
  max-width: 0 !important;
  overflow: hidden !important;
}

.styles_celulaEllipsis__AdNTh {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.styles_colunaAcoes__3FepW {
  width: 96px !important;
}

.styles_btnPDF__7Nwbl {
  width: 100% !important;
  background-color: #0f2047 !important;
  color: #ffffff !important;
  border-color: #ffffff !important;
  border-width: 1px !important;
  border-style: solid !important;
  font-family: "Inter" !important;
  font-size: 16px !important;
  margin-top: 8px !important;
  margin-bottom: 8px !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
  text-transform: capitalize !important;
  height: 36px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/TabelaDinamica/styles.module.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,4BAA4B;EAC5B,6BAA6B;EAC7B,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,4BAA4B;EAC5B,6BAA6B;EAC7B,6BAA6B;EAC7B,gCAAgC;EAChC,4BAA4B;EAC5B,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,0BAA0B;EAC1B,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,+BAA+B;EAC/B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,0BAA0B;EAC1B,0BAA0B;EAC1B,6BAA6B;EAC7B,6BAA6B;EAC7B,oCAAoC;EACpC,qCAAqC;EACrC,uBAAuB;AACzB","sourcesContent":[".backgroundTable {\n  padding-top: -40px !important;\n  margin-left: 40px !important;\n  margin-right: 40px !important;\n  padding-bottom: 30px !important;\n}\n\n.tabelaGeral {\n  background-color: #ffffff;\n  border-radius: 0 0 6px 6px;\n  padding-left: 4px !important;\n  padding-right: 4px !important;\n  margin-top: -28px !important;\n  padding-bottom: 4px !important;\n}\n\n.tabelaLoading {\n  background-color: #ffffff;\n  border-radius: 0 0 6px 6px;\n  padding-left: 4px !important;\n  padding-right: 4px !important;\n  padding-top: 150px !important;\n  padding-bottom: 150px !important;\n  margin-top: -28px !important;\n  justify-content: center;\n  align-content: center;\n}\n\n.paginacaoTabela {\n  padding: 0;\n  border-radius: 0 0 6px 6px;\n  background-color: #0f2047 !important;\n  color: #ffffff !important;\n}\n\n.tableHeader {\n  border-radius: 6px 6px 0 0;\n}\n\n.tabelaHeader {\n  font-family: \"Inter\" !important;\n  background-color: #0f2047 !important;\n  color: #ffffff !important;\n  font-size: 16px !important;\n  font-weight: 500 !important;\n  padding-top: 2px !important;\n  padding-bottom: 4px !important;\n}\n\n.iconeEditar {\n  color: #18316e !important;\n}\n\n.iconeEditar:hover {\n  transform: scale(0.95) !important;\n}\n\n.iconeExcluir {\n  color: #ff0000 !important;\n  margin-left: 4% !important;\n}\n\n.iconeAtivo {\n  width: 20px !important;\n  height: auto !important;\n}\n\n.boxAcoes {\n  vertical-align: middle !important;\n  display: flex;\n  flex-direction: row;\n}\n\n.customCell {\n  padding-top: 0px !important;\n  padding-bottom: 0px !important;\n  font-family: \"Inter\" !important;\n  color: #000000 !important;\n  word-wrap: break-word;\n}\n\n.tableContainerFixa {\n  overflow-x: hidden !important;\n}\n\n.tabelaFixa {\n  table-layout: fixed !important;\n  width: 100% !important;\n}\n\n.celulaTruncada {\n  max-width: 0 !important;\n  overflow: hidden !important;\n}\n\n.celulaEllipsis {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.colunaAcoes {\n  width: 96px !important;\n}\n\n.btnPDF {\n  width: 100% !important;\n  background-color: #0f2047 !important;\n  color: #ffffff !important;\n  border-color: #ffffff !important;\n  border-width: 1px !important;\n  border-style: solid !important;\n  font-family: \"Inter\" !important;\n  font-size: 16px !important;\n  margin-top: 8px !important;\n  margin-bottom: 8px !important;\n  border-radius: 8px !important;\n  transition: all 0.3s ease !important;\n  text-transform: capitalize !important;\n  height: 36px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"backgroundTable": `styles_backgroundTable__Ktc63`,
	"tabelaGeral": `styles_tabelaGeral__g6Yiw`,
	"tabelaLoading": `styles_tabelaLoading__JS+Yh`,
	"paginacaoTabela": `styles_paginacaoTabela__Nn59a`,
	"tableHeader": `styles_tableHeader__-TOwt`,
	"tabelaHeader": `styles_tabelaHeader__Svz-L`,
	"iconeEditar": `styles_iconeEditar__CnFDs`,
	"iconeExcluir": `styles_iconeExcluir__gTgZ4`,
	"iconeAtivo": `styles_iconeAtivo__oKypm`,
	"boxAcoes": `styles_boxAcoes__o7pUE`,
	"customCell": `styles_customCell__UaEmR`,
	"tableContainerFixa": `styles_tableContainerFixa__x0zXN`,
	"tabelaFixa": `styles_tabelaFixa__l+GGn`,
	"celulaTruncada": `styles_celulaTruncada__NnaRQ`,
	"celulaEllipsis": `styles_celulaEllipsis__AdNTh`,
	"colunaAcoes": `styles_colunaAcoes__3FepW`,
	"btnPDF": `styles_btnPDF__7Nwbl`
};
export default ___CSS_LOADER_EXPORT___;
